import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/core/authentication/authentication.service';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'verified-page',
  templateUrl: './verified-page.component.html',
  styleUrls: ['./verified-page.component.scss']
})
export class VerifiedPageComponent implements OnInit {

  isLoading: boolean = false;
  countdown: number = 10; 
  countdownInterval: any;
  emailVerified: boolean = false;
  emailNotVerified: boolean = false;

  constructor(private route: ActivatedRoute, private authService: AuthService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const ID = +params.get('ID') || 0;
      const UUID = params.get('UUID') || '';
        this.authService.verifyEmail(ID).subscribe({
          next: res => {
            console.log(res);
            if(res.message === 'Email Verified') {
              this.startCountdown();
              this.emailVerified = true;
            } else {
              this.startCountdown();
              this.emailNotVerified = true;
            }
          },
          error: err => {
            console.log(err);
          }
        })
    });
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.closeWindow();
      }
    }, 1000);
  }

  closeWindow() {
    clearInterval(this.countdownInterval);
    window.close();
  }
}
